import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import RobotPlanningCalendar from "./RobotPlanningCalendar";
import RobotProduction from "./RobotProduction";
import { triggerSave } from "../../core/save/pendingSave";
import "../production/ProductionTable.css";

const TABS = [
    { key: "urgences", label: "Urgences", path: "/robot-production" },
    { key: "planning", label: "Planning", path: "/robot-planning" },
];

export default function RobotTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const activeTab = location.pathname === "/robot-planning" ? "planning" : "urgences";

    const handleTabClick = async (path) => {
        if (location.pathname === path) return;
        await triggerSave();
        navigate(path);
    };

    // Les onglets s'affichent dans l'en-tête de chaque vue, à côté de son titre.
    const headerTabs = (
        <div role="tablist" aria-label="Robot" className="rbt-tabs">
            {TABS.map(tab => {
                const active = activeTab === tab.key;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={active}
                        onClick={() => handleTabClick(tab.path)}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );

    return (
        <div style={{ height: "100%", minHeight: 0, overflow: "hidden" }}>
            {activeTab === "planning"
                ? <RobotPlanningCalendar headerTabs={headerTabs} />
                : <RobotProduction headerTabs={headerTabs} />}
        </div>
    );
}
